export default __webpack_public_path__ + "static/media/Salient Features_USHPP_8.ac0593c7.jpg";